// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-box {
  height: 200px;
  width: 100%;
  position: relative;
}
.image-box img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: transform 0.3s ease-in-out;
}

.sm-date {
  border: 1px solid #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
}

.big-view-image {
  height: auto;
  width: 100%;
  object-fit: contain; /* Ensures the entire image is visible without cropping */
  max-width: 100%; /* Ensures the image doesn't exceed the modal width */
  cursor: pointer;
}

.flex-left-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 2px;
}

.flex-right-center {
  display: flex;
  justify-content: end;
  align-items: center;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  z-index: 1000;
}

.full-screen-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: transparent;
  border: none;
  color: #ffffff;
  font-size: 24px;
}`, "",{"version":3,"sources":["webpack://./src/Components/ScreenPhoto.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AACF;AAAE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,sCAAA;AAEJ;;AAEA;EACI,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEE;EACE,YAAA;EACA,WAAA;EACA,mBAAA,EAAA,yDAAA;EACA,eAAA,EAAA,qDAAA;EACA,eAAA;AACJ;;AACA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;AAEF;;AAAA;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AAGF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAGF","sourcesContent":[".image-box {\n  height: 200px;\n  width: 100%;\n  position: relative;\n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    transition: transform 0.3s ease-in-out;\n  }\n  \n}\n.sm-date{\n    border: 1px solid #000;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 10px;\n  }\n\n  .big-view-image {\n    height: auto;\n    width: 100%;\n    object-fit: contain; /* Ensures the entire image is visible without cropping */\n    max-width: 100%; /* Ensures the image doesn't exceed the modal width */\n    cursor: pointer;\n  }\n.flex-left-center{\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding-left: 2px;\n}\n.flex-right-center{\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 24px;\n  z-index: 1000;\n}\n\n.full-screen-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.close-button {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background-color: transparent;\n  border: none;\n  color: #ffffff;\n  font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
